import lf from 'localforage';

lf.config({
  driver: lf.LOCALSTORAGE,
  name: 'doconApp',
  storeName: process.env.REACT_APP_STORE_NAME || 'reception', // Should be alphanumeric, with underscores.
  version: 1.0,
  size: 4980736, // Size of database, in bytes. WebSQL-only for now.
  description: 'docon reception localstorage',
});

// TODO: Repeated Code
const storageService = {
  USER: 'user',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  get: async <T>(key: string): Promise<T | null> => lf.getItem<T>(key),
  set: async <T>(key: string, value: T): Promise<T> => lf.setItem<T>(key, value),
  remove: async (key: string): Promise<void> => lf.removeItem(key),
  clear: async (): Promise<void> => lf.clear(),
  length: async (): Promise<number> => lf.length(),
  key: async (keyIndex: number): Promise<string> => lf.key(keyIndex),
  keys: async (): Promise<string[]> => lf.keys(),
  iterate: async <T, U>(
    iteratee: (value: T, key: string, iterationNumber: number) => U,
  ): Promise<U> => lf.iterate<T, U>(iteratee),
};

export default storageService;
